import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

class ToolTips extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
        <div key={1} className="alert alert-info--light" role="alert">
          <FontAwesomeIcon icon={faInfoCircle} />{this.props.toolTipText}
        </div>
    );
  }
}

export default ToolTips;
